import { render, staticRenderFns } from "./EditSoftwareBugTemplate.vue?vue&type=template&id=3f009609&scoped=true"
import script from "./EditSoftwareBugTemplate.vue?vue&type=script&lang=js"
export * from "./EditSoftwareBugTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f009609",
  null
  
)

export default component.exports